<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <h3>{{ $t("NAVBAR.generalSettings") }}</h3>

          <!-- Value Added Tax (VAT) Percentage -->
          <base-input
            col="6"
            type="number"
            :max="100"
            :min="0"
            :step="1"
            :placeholder="$t('PLACEHOLDERS.tax') + ' (%)'"
            v-model.number="data.tax"
            required
          />

          <!-- Service Provider Commission Percentage -->
          <base-input
            col="6"
            type="number"
            :max="100"
            :min="0"
            :step="1"
            :placeholder="$t('PLACEHOLDERS.appCommissionProvider') + ' (%)'"
            v-model.number="data.app_commission_provider"
            required
          />

          <!-- Allowed Time Before Order Cancellation -->
          <base-input
            col="6"
            type="number"
            :min="1"
            :max="1000000"
            :step="1"
            :placeholder="$t('PLACEHOLDERS.cancel_grace_period')"
            v-model.number="data.cancel_grace_period"
            required
          />

          <!-- Order Cancellation Penalty Amount -->
          <base-input
            col="6"
            type="number"
            :min="0.01"
            :max="1000000"
            :step="0.01"
            :placeholder="$t('PLACEHOLDERS.cancellation_fee')"
            v-model.number="data.cancellation_fee"
            required
          />
          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- End:: Single Step Form Content -->
  </div>
</template>

<script>
export default {
  name: "GeneralSettings",

  data() {
    return {
      isWaitingRequest: false,
      data: {
        tax: 0,
        app_commission_provider: 0,
        cancel_grace_period: null,
        cancellation_fee: null,
      },
    };
  },

  methods: {
    async getDataToEdit() {
      try {
        let res = await this.$axios.get(`settings?key=dashboard_settings`);
        const value = res.data.data.data[0].value;

        this.data.tax = value.tax || 0;
        this.data.app_commission_provider = value.app_commission_provider || 0;
        this.data.cancel_grace_period = value.cancel_grace_period;
        this.data.cancellation_fee = value.cancellation_fee;
      } catch (error) {
        console.error(error.response.data.message);
      }
    },
    // validateFormInputs() {
    //   this.isWaitingRequest = true;

    //   if (!this.data.tax) {
    //     this.isWaitingRequest = false;
    //     this.$message.error(this.$t("VALIDATION.tax"));
    //     return;
    //   } else if (this.data.tax < -1 || this.data.tax > 100) {
    //     this.isWaitingRequest = false;
    //     this.$message.error(this.$t("VALIDATION.tax_min"));
    //     return;
    //   } else if (!this.data.search_range) {
    //     this.isWaitingRequest = false;
    //     this.$message.error(this.$t("VALIDATION.search_range"));
    //     return;
    //   } else if (this.data.search_range < 0) {
    //     this.isWaitingRequest = false;
    //     this.$message.error(this.$t("VALIDATION.search_range_min"));
    //     return;
    //   } else if (!this.data.app_commission_provider) {
    //     this.isWaitingRequest = false;
    //     this.$message.error(this.$t("VALIDATION.app_commission_provider"));
    //     return;
    //   } else if (
    //     this.data.app_commission_provider <= 0 ||
    //     this.data.app_commission_provider > 100
    //   ) {
    //     this.isWaitingRequest = false;
    //     this.$message.error(this.$t("VALIDATION.app_commission_provider_min"));
    //     return;
    //   } else if (!this.data.installment_fees) {
    //     this.isWaitingRequest = false;
    //     this.$message.error(this.$t("VALIDATION.installment_fees"));
    //     return;
    //   } else if (
    //     this.data.installment_fees < 0 ||
    //     this.data.installment_fees > 100
    //   ) {
    //     this.isWaitingRequest = false;
    //     this.$message.error(this.$t("VALIDATION.installment_fees_min"));
    //     return;
    //   } else if (!this.data.number_of_subscription_days) {
    //     this.isWaitingRequest = false;
    //     this.$message.error(this.$t("VALIDATION.number_of_subscription_days"));
    //     return;
    //   } else if (this.data.number_of_subscription_days < 0) {
    //     this.isWaitingRequest = false;
    //     this.$message.error(
    //       this.$t("VALIDATION.number_of_subscription_days_min")
    //     );
    //     return;
    //   } else if (!this.data.min_provider_wallet) {
    //     this.isWaitingRequest = false;
    //     this.$message.error(this.$t("VALIDATION.min_provider_wallet"));
    //     return;
    //   } else if (!this.data.subscription_reminder) {
    //     this.isWaitingRequest = false;
    //     this.$message.error(this.$t("VALIDATION.subscription_reminder"));
    //     return;
    //   } else if (this.data.subscription_reminder < 0) {
    //     this.isWaitingRequest = false;
    //     this.$message.error(this.$t("VALIDATION.subscription_reminder_min"));
    //     return;
    //   } else if (!this.data.subscription_fees) {
    //     this.isWaitingRequest = false;
    //     this.$message.error(this.$t("VALIDATION.subscription_fees"));
    //     return;
    //   } else if (this.data.subscription_fees < 0) {
    //     this.isWaitingRequest = false;
    //     this.$message.error(this.$t("VALIDATION.subscription_fees_min"));
    //     return;
    //   } else {
    //     this.submitForm();
    //     return;
    //   }
    // },

    validateFormInputs() {
      this.isWaitingRequest = true;

      const rules = [
        {
          field: "tax",
          required: true,
          min: 0,
          max: 100,
          errorKey: "VALIDATION.tax_range",
        },
        {
          field: "app_commission_provider",
          required: true,
          min: 0,
          max: 100,
          errorKey: "VALIDATION.app_commission_provider_range",
        },
        {
          field: "cancel_grace_period",
          required: true,
          min: 1,
          max: 1000000,
          errorKey: "VALIDATION.cancel_grace_period_range",
        },
        {
          field: "cancellation_fee",
          required: true,
          min: 0.01,
          max: 1000000,
          errorKey: "VALIDATION.cancellation_fee_range",
        },
      ];

      for (const rule of rules) {
        const value = this.data[rule.field];

        if (
          rule.required &&
          (value === null || value === undefined || value === "")
        ) {
          this.isWaitingRequest = false;
          this.$message.error(this.$t(`VALIDATION.${rule.field}`));
          return;
        }

        if (typeof rule.min === "number" && value < rule.min) {
          this.isWaitingRequest = false;
          this.$message.error(this.$t(rule.errorKey));
          return;
        }

        if (typeof rule.max === "number" && value > rule.max) {
          this.isWaitingRequest = false;
          this.$message.error(this.$t(rule.errorKey));
          return;
        }
      }

      this.submitForm();
    },
    async submitForm() {
      this.isWaitingRequest = true;
      const REQUEST_DATA = new FormData();
      REQUEST_DATA.append("key", "dashboard_settings");

      REQUEST_DATA.append("value[tax]", this.data.tax);
      REQUEST_DATA.append(
        "value[app_commission_provider]",
        this.data.app_commission_provider
      );
      REQUEST_DATA.append(
        "value[cancel_grace_period]",
        this.data.cancel_grace_period
      );
      REQUEST_DATA.append(
        "value[cancellation_fee]",
        this.data.cancellation_fee
      );

      try {
        await this.$axios({
          method: "POST",
          url: `settings?key=dashboard_settings`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.savedSuccessfully"));
        this.getDataToEdit();
      } catch (error) {
        console.log("error", error.response.data.message);
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
  },
  created() {
    this.getDataToEdit();
  },
};
</script>

<style scoped>
.item-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
</style>
